export function storageGet(key: string) {
  try { return globalThis.localStorage?.getItem(key) ?? null; }
  catch { return null; }
}

export function storageSet(key: string, value: string) {
  try { globalThis.localStorage?.setItem(key, value); }
  catch { /* Safari private/restricted storage must not block the EB login. */ }
}

export function prefersReducedMotion() {
  try { return typeof matchMedia === 'function' && matchMedia('(prefers-reduced-motion: reduce)').matches; }
  catch { return false; }
}

export function watchReducedMotion(update: (matches: boolean) => void) {
  if (typeof matchMedia !== 'function') { update(false); return () => undefined; }
  const media = matchMedia('(prefers-reduced-motion: reduce)');
  const listener = (event: MediaQueryListEvent | MediaQueryList) => update(event.matches);
  update(media.matches);
  if (typeof media.addEventListener === 'function') {
    media.addEventListener('change', listener);
    return () => media.removeEventListener('change', listener);
  }
  media.addListener(listener);
  return () => media.removeListener(listener);
}

export async function fetchWithTimeout(
  input: RequestInfo | URL,
  init: RequestInit,
  timeoutMs: number,
) {
  if (typeof AbortController === 'undefined') return fetch(input, init);
  const controller = new AbortController();
  const upstream = init.signal;
  const abort = () => controller.abort();
  if (upstream?.aborted) controller.abort();
  else upstream?.addEventListener('abort', abort, { once: true });
  const timer = globalThis.setTimeout(abort, timeoutMs);
  try { return await fetch(input, { ...init, signal: controller.signal }); }
  finally {
    globalThis.clearTimeout(timer);
    upstream?.removeEventListener('abort', abort);
  }
}
